import {
  Box,
  Link,
  ReactHtmlParser,
  Typography,
  SpanTypography,
} from "@/src/components/journal-site/articles/article-meta-data";
import NextLink from "next/link";

const EicNotes = ({ eicNotes }: { eicNotes: any }) => (
  <Box role="doc-afterword" sx={{
    mt: 2
  }}>
    <Typography component="b" id="eicNotes">
      <Link
        component={NextLink}
        href="#eicNotes"
        underline="none"
        sx={{
          display: "flex",
          alignItems: "center"
        }}>
        <SpanTypography sx={{
          color: "default"
        }}>
          </SpanTypography>
        <SpanTypography component="span" sx={{
          ml: 1
        }}>
          EIC Notes
        </SpanTypography>
      </Link>
    </Typography>
    {eicNotes.map((note: { note: string }, index: number) => (
      <Box key={`note-${index}`} sx={{ display: "none" }}>
        <Typography>{ReactHtmlParser(note?.note || "")}</Typography>
      </Box>
    ))}
  </Box>
);

export default EicNotes;
